import React from 'react'

export default ({
  className = ''
}) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" width="89.645" height="116.538" viewBox="0 0 89.645 116.538"><path d="M-7.5-18.75V97.788H82.145V10.8L80.884,9.4,53.991-17.489l-1.4-1.261ZM1.464-9.786H46.287V17.108H73.18V88.824H1.464ZM55.251-3.342,66.737,8.143H55.251ZM14.911,26.072v8.964H59.734V26.072Zm0,17.929v8.964H59.734V44Zm0,17.929v8.964H59.734V61.93Z" transform="translate(7.5 18.75)"/></svg>
  )
